import styled from '@emotion/styled';
import ActiveStatus from '@components/ActiveStatus';
import {absolutePosition} from '@styles/reusable';
import {AttendanceStatus} from '@models/AttendanceType';

export const GridCardContainer = styled.div<{ selected: boolean; blurred: boolean; mock?: boolean}>`
  position: relative;
  width: 100%;
  height: 100%;
  min-height: 174px;
  display: flex;
  flex-direction: column;
  transition: transform 0.2s;
  opacity: ${({ blurred }) => (blurred ? 0.5 : 1)} !important;
  will-change: width, height, opacity, transform;
  background: ${(props) => (props.mock ? (props) => props.theme.colors.mockColor : 'var(--backgroundColor)')};
  cursor: ${({ blurred }) => (blurred ? 'default' : 'pointer')};
  border-radius: ${(props) => props.theme.pillBorderRadius}px;

  &::before {
    ${absolutePosition}
    content: ' ';
    width: calc(100% + 16px);
    height: calc(100% + 16px);
    left: -8px;
    top: -8px;
    transition: box-shadow 0.2s;
    box-shadow: inset 0px 0px 0px ${({ selected }) => (selected ? (props) => props.theme.selectionBorderSize : 0)}px
      ${(props) => props.theme.colors.selectionBorderColor};
    border-radius: ${(props) => props.theme.pillBorderRadius}px;
    z-index: 1;
    pointer-events: none;
  }
`;

export const GridCardStudentInfo = styled.div<{ mock?: boolean, backgroundColor?:boolean  }>`
  position: absolute;
  width: 100%;
  bottom: 0;
  left: 0;
  min-height: 54px;
  padding: 10px;
  display: flex;
  justify-content: space-between;
  overflow: hidden;
  z-index: 1;

  background: ${(props) => (props.mock ? props.theme.colors.mockColor : (props.backgroundColor? 'rgba(255,255,255,0.9)':'var(--backgroundColor)'))};

  border-bottom-left-radius: ${(props) => props.theme.pillBorderRadius}px;
  border-bottom-right-radius: ${(props) => props.theme.pillBorderRadius}px;
`;

export const ActiveIndicator = styled(ActiveStatus)`
  position: absolute;
  top: 8px;
  left: 8px;
  width: 9px;
  height: 9px;
  z-index: 1;
`;

export const StudentImage = styled.div`
  position: relative;
  width: 100%;
  height: 100%;
  border-radius: ${(props) => props.theme.pillBorderRadius}px;
  overflow: hidden;

  img {
    width: 100% !important;
    height: 100% !important;
  }
`;

/**
 * Details
 */
export const DetailsContainer = styled.div<{ attendanceStatus: string, contrast?: boolean }>`
  position: relative;
  width: 100%;
  color: ${(props) => (props.contrast? props.theme.colors.mainTextColor: (props.attendanceStatus === AttendanceStatus.Unknown ? props.theme.colors.mainTextColor : props.theme.colors.white))};
  display: flex;
  flex-direction: column;
`;

export const DetailsLine = styled.div`
  /* background-color: yellow; */

  width: 100%;
  display: flex;
  justify-content: space-between;
`;

export const DetailsTitleTop = styled.h3`
  font-weight: ${(props) => props.theme.weights.bold};
  font-size: ${(props) => props.theme.fontSizes.small}px;
`;

export const DetailsTitleBottom = styled.h3`
  font-weight: ${(props) => props.theme.weights.regular};
  font-size: ${(props) => props.theme.fontSizes.tiny}px;
`;
